// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-tabs {
  width: 90%;
  margin: 2.5rem auto;
  padding: 5rem 0;
}
campaign-main .sync-bar {
  margin: 3.75rem 0;
}
.campaign-main .sync-bar h4 {
  color: red;
  font-weight: bold;
  margin-bottom: 1.25rem;
}
.campaign-main .ant-progress-bg {
  height: 0.625rem !important;
}
.campaign-main .info h5 {
  text-align: left;
  margin: 3.125rem 0;
  background-color: yellow;
  width: max-content;
  color: red;
  border-radius: 0.25rem;
  padding: 0.25rem 10.313rem;
}

.campaign-main h2 {
  text-align: center;
  letter-spacing: 0.063rem;
  margin-bottom: 1.875rem;
}
.campaign-filter {
  display: flex;
  justify-content: flex-end;
  margin: 1.25rem 0;
  align-items: center;
  flex-wrap: wrap;
}
.campaign-filter button,
.campaign-main .sync-button {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 0.625rem 1.25rem 0.625rem;
  height: 3.75rem;
  /* flex-wrap: wrap; */
  border-radius: 0.313rem;
  min-width: 12.5rem;
}
.campaign-main .sync-button {
  margin-left: auto;
}
.campaign-main .sync-heading {
  text-align: center;
  color: red !important;
  text-decoration: underline;
  margin: 3.125rem 0;
  letter-spacing: 0.063rem;
}
.campaign-main h4 {
  margin-bottom: 0;
  text-align: center;
}

.whatsapp-campaign-btn {
  display: flex;
  align-items: center;
  border-color: rgb(189, 189, 189);
  gap: 4px;
}

.whatsapp-campaign-btn:hover {
  border-color: #25d366 !important;
}

.campaign-container {
  width: 95%;
}
.campaign-container .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.campaign-container .header .campaign-buttons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
}
.campaign-container .header .campaign-buttons button {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
  min-width: 200px;
  justify-content: center;
}

.campaign-container .filter .more-button {
  border-radius: 0.313rem;
  display: flex;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  gap: 10px;
}
.audience-upload .ant-upload {
  width: 100%;
}
.audience-upload .ant-upload-list-item-info {
  padding: 14px 10px !important;
  border-radius: 4px;
}

.conditionChart {
  overflow-y: hidden;
  overflow-x: scroll;
}

.condition-table tr:first-child > th:first-child {
  width: 10%;
}

.condition-table tr:first-child > th:last-child {
  width: 20%;
}
.condition-table .ant-table-cell {
  color: #778899;
}

.ant-popover-disabled-compatible-wrapper {
  display: block !important;
}
.ant-popover-content .ant-popover-inner-content {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/campaign.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".campaign-tabs {\r\n  width: 90%;\r\n  margin: 2.5rem auto;\r\n  padding: 5rem 0;\r\n}\r\ncampaign-main .sync-bar {\r\n  margin: 3.75rem 0;\r\n}\r\n.campaign-main .sync-bar h4 {\r\n  color: red;\r\n  font-weight: bold;\r\n  margin-bottom: 1.25rem;\r\n}\r\n.campaign-main .ant-progress-bg {\r\n  height: 0.625rem !important;\r\n}\r\n.campaign-main .info h5 {\r\n  text-align: left;\r\n  margin: 3.125rem 0;\r\n  background-color: yellow;\r\n  width: max-content;\r\n  color: red;\r\n  border-radius: 0.25rem;\r\n  padding: 0.25rem 10.313rem;\r\n}\r\n\r\n.campaign-main h2 {\r\n  text-align: center;\r\n  letter-spacing: 0.063rem;\r\n  margin-bottom: 1.875rem;\r\n}\r\n.campaign-filter {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin: 1.25rem 0;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n.campaign-filter button,\r\n.campaign-main .sync-button {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  margin: 0 0.625rem 1.25rem 0.625rem;\r\n  height: 3.75rem;\r\n  /* flex-wrap: wrap; */\r\n  border-radius: 0.313rem;\r\n  min-width: 12.5rem;\r\n}\r\n.campaign-main .sync-button {\r\n  margin-left: auto;\r\n}\r\n.campaign-main .sync-heading {\r\n  text-align: center;\r\n  color: red !important;\r\n  text-decoration: underline;\r\n  margin: 3.125rem 0;\r\n  letter-spacing: 0.063rem;\r\n}\r\n.campaign-main h4 {\r\n  margin-bottom: 0;\r\n  text-align: center;\r\n}\r\n\r\n.whatsapp-campaign-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  border-color: rgb(189, 189, 189);\r\n  gap: 4px;\r\n}\r\n\r\n.whatsapp-campaign-btn:hover {\r\n  border-color: #25d366 !important;\r\n}\r\n\r\n.campaign-container {\r\n  width: 95%;\r\n}\r\n.campaign-container .header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.campaign-container .header .campaign-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  justify-content: flex-end;\r\n}\r\n.campaign-container .header .campaign-buttons button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  min-height: 40px;\r\n  min-width: 200px;\r\n  justify-content: center;\r\n}\r\n\r\n.campaign-container .filter .more-button {\r\n  border-radius: 0.313rem;\r\n  display: flex;\r\n  align-items: center;\r\n  width: fit-content;\r\n  gap: 10px;\r\n}\r\n.audience-upload .ant-upload {\r\n  width: 100%;\r\n}\r\n.audience-upload .ant-upload-list-item-info {\r\n  padding: 14px 10px !important;\r\n  border-radius: 4px;\r\n}\r\n\r\n.conditionChart {\r\n  overflow-y: hidden;\r\n  overflow-x: scroll;\r\n}\r\n\r\n.condition-table tr:first-child > th:first-child {\r\n  width: 10%;\r\n}\r\n\r\n.condition-table tr:first-child > th:last-child {\r\n  width: 20%;\r\n}\r\n.condition-table .ant-table-cell {\r\n  color: #778899;\r\n}\r\n\r\n.ant-popover-disabled-compatible-wrapper {\r\n  display: block !important;\r\n}\r\n.ant-popover-content .ant-popover-inner-content {\r\n  width: 100% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
